module.exports = __webpack_public_path__ + "logo_fond_transparent.svg?87e6ec929ea8a7a903e8ab1f4983833f";


//////////////////
// WEBPACK FOOTER
// ./src/img/navbar/logo_fond_transparent.svg
// module id = 15
// module chunks = 0